export enum FileRoleEnum {
    user = "user",
    advisor = "advisor"
}